/**
 * ArchivesBanner — centralized "AI Chat Archives" entry point.
 * Rendered at the top of the Cloud GM AI Control Hub Tier-1 hub.
 */
import { motion } from 'framer-motion';
import { MessageSquare, ChevronRight, ShieldCheck } from 'lucide-react';

export function ArchivesBanner({ language, onClick }) {
  return (
    <motion.button
      type="button"
      whileHover={{ y: -2 }}
      whileTap={{ scale: 0.995 }}
      onClick={onClick}
      className="w-full text-start bg-gradient-to-r from-[#d4af37]/15 via-amber-500/10 to-transparent border border-[#d4af37]/40 hover:border-[#d4af37]/70 rounded-2xl p-5 mb-5 transition-all group flex items-center gap-4 overflow-hidden"
      data-testid="ai-chat-archives-btn"
    >
      <div className="w-14 h-14 rounded-2xl bg-[#d4af37]/20 border border-[#d4af37]/40 text-[#d4af37] flex items-center justify-center shrink-0 shadow-lg">
        <MessageSquare className="h-7 w-7" />
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 flex-wrap">
          <h3 className="text-lg font-bold text-white">
            {language === 'ar' ? 'محادثات الذكاء الاصطناعي' : 'AI Conversations'}
          </h3>
          <span className="inline-flex items-center gap-1 text-[9px] font-bold text-emerald-300 uppercase tracking-wider bg-emerald-500/15 border border-emerald-500/40 px-1.5 py-0.5 rounded">
            <ShieldCheck className="h-2.5 w-2.5" />
            {language === 'ar' ? 'مركزي' : 'Central'}
          </span>
        </div>
        <p className="text-xs text-white/60 mt-1 line-clamp-2">
          {language === 'ar'
            ? 'استعرض وراجع كل محادثات الذكاء الاصطناعي من جميع المنصات (ASB606، CloudGM Customer، CloudGM Business) في مكان واحد.'
            : 'Review all AI chats across every platform (ASB606, CloudGM Customer, CloudGM Business) in one hub.'}
        </p>
      </div>
      <ChevronRight className={`h-6 w-6 text-[#d4af37]/70 group-hover:text-[#d4af37] transition-colors shrink-0 ${language === 'ar' ? 'rotate-180' : ''}`} />
    </motion.button>
  );
}
